'use client';

import {
  type Supplier,
  apiRoutes,
  httpClient,
  type DefaultQueryError,
  type Service,
  type SpecialRequest,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

export type SupplierProfile = {
  supplier: Supplier;
  services: Service[];
  requests: SpecialRequest[];
  files: any[];
};

export const getSupplierProfileFn = async () => {
  const response = await httpClient.get<SupplierProfile>(
    apiRoutes.supplier.profile
  );
  return response.data;
};

export const useGetSupplierProfile = (
  opts?: Omit<UseQueryOptions<SupplierProfile, DefaultQueryError>, 'queryKey'>
) =>
  useQuery<SupplierProfile, DefaultQueryError>({
    queryKey: [apiRoutes.supplier.profile],
    queryFn: getSupplierProfileFn,
    ...opts,
  });
